import React from "react";

/**
 * Loading + "couldn't load this profile" early-return JSX extracted
 * from ProfilePage.jsx (Jun 8, 2026) to keep that file under the
 * 600-line product rule.
 *
 * Caller passes one of: state="loading" (spinner) | state="notfound"
 * (retry / home buttons). All copy and styles are unchanged from
 * the inline original — purely a render extraction.
 */
export function ProfileLoadingError({ state, onHome }) {
  if (state === "loading") {
    return (
      <div className="h-[calc(100dvh-4rem)] bg-black flex items-center justify-center overflow-hidden">
        <div className="animate-spin h-12 w-12 border-4 border-emerald-500 border-t-transparent rounded-full" />
      </div>
    );
  }
  return (
    <div className="h-[calc(100dvh-4rem)] bg-black flex items-center justify-center px-6 overflow-hidden">
      <div className="max-w-md text-center text-white space-y-4">
        <p className="text-lg font-semibold">We couldn't load this profile.</p>
        <p className="text-gray-400 text-sm">It might be a network blip, or the user may have deactivated. Try again, or head back home.</p>
        <div className="flex gap-3 justify-center pt-2">
          <button
            onClick={() => window.location.reload()}
            className="px-4 py-2 bg-emerald-600 hover:bg-emerald-700 rounded-md font-medium"
            data-testid="profile-retry-btn"
          >Try again</button>
          <button
            onClick={onHome}
            className="px-4 py-2 bg-gray-800 hover:bg-gray-700 rounded-md font-medium"
            data-testid="profile-home-btn"
          >Go home</button>
        </div>
      </div>
    </div>
  );
}
